import { toast } from 'react-toastify';
import { ADD_EMP, EDIT_EMP, GET_EMP,
  SEARCH_EMP, DELETE_EMP, UPLOAD_BULK_EMP } from "../action/constant";

const initialState = {
  loading:false,
  empData:[],
  err:{},
  totaldocuments:1,
  empModal:false,
  bulkEmpModal:false,
  rowM:{
    name:'',
    department:'',
    phone_number:'',
    email:'',
  },
  edit:false,
  uploadEmp:{},
  uploadLoading:false,
}

export default function addEmpReducer(state = initialState,action){
       switch (action.type) {
         case 'TOGGLE_BULK_MODAL_OPEN':
           return {
             ...state,
             bulkEmpModal:true,
           }
        case 'TOGGLE_BULK_MODAL_CLOSE':
          return {
            ...state,
            bulkEmpModal:false,
          }
         case "TOGGLE_MODAL_OPEN":
           return {
             ...state,
             rowM:action.row,
             empModal:true,
             edit:action.edit,
           }
          case "TOGGLE_MODAL_CLOSE":
            return {
              ...state,
              empModal:false,
              rowM:{
                name:'',
                department:'',
                phone_number:'',
                email:'',
              },
              edit:action.edit,
            }
         case GET_EMP.PENDING:
           return {
             ...state,
             loading:true,
             err:{},
           }
          case GET_EMP.SUCCESS:
            return {
              ...state,
              loading:false,
              empData:action.data.employee,
              totaldocuments:action.data.totaldocuments,
              err:{},
            }
          case GET_EMP.ERROR:
            return {
              ...state,
              loading:false,
              err:action.err,
            }
         case ADD_EMP.PENDING:
           return {
             ...state,
             loading:true,
             err:{},
           }
          case ADD_EMP.SUCCESS:
            return {
              ...state,
              loading:false,
              err:{},
              empModal:false,
              empData:[...state.empData,action.data]
            }
          case ADD_EMP.ERROR:
            return {
              ...state,
              loading:false,
              err:action.err
            }
          case EDIT_EMP.PENDING:
            return {
              ...state,
              loading:true,
              err:{},
            }
          case EDIT_EMP.SUCCESS:
            return {
              ...state,
              loading:false,
              empModal:false,
              err:{},
            }
          case EDIT_EMP.ERROR:
            return {
              ...state,
              loading:false,
              empModal:false,
              err:action.err,
            }
          case SEARCH_EMP.PENDING:
            return {
              ...state,
              loading:true,
              err:{},
            }
          case SEARCH_EMP.SUCCESS:
            return {
              ...state,
              loading:false,
              err:{},
              empData:action.data
            }
          case SEARCH_EMP.ERROR:
            return {
              ...state,
              loading:false,
              err:action.err,
            }
          case DELETE_EMP.PENDING:
            return {
              ...state,
              loading:true,
              err:{},
            }
          case DELETE_EMP.SUCCESS:
            toast.dismiss();
            toast.success('Employee Deleted Successfully');
            return {
              ...state,
              loading:false,
              err:{},
            }
          case DELETE_EMP.ERROR:
            toast.error('Error white deleting Employee')
            return {
              ...state,
              loading:false,
              err:{},
            }
          case UPLOAD_BULK_EMP.PENDING:
            return {
              ...state,
              uploadLoading:true,
              err:{},
            }
          case UPLOAD_BULK_EMP.SUCCESS:
            return {
              ...state,
              uploadLoading:false,
              err:{},
              uploadEmp:action.data
            }
          case UPLOAD_BULK_EMP.ERROR:
            return {
              ...state,
              uploadLoading:false,
              err:action.err,
            }
         default:
           return state;
       }
}
